<template>
  <div class="product-bubble-wrapper">
    <div v-show="validateMessage" class="product-bubble offer-price-bubble offer-price-validate-bubble">
      {{ validateMessage }}
    </div>
    <div v-show="bubbleMessage && !validateMessage" class="product-bubble offer-price-bubble offer-price-warning-bubble">
      {{ bubbleMessage }}
    </div>

    <input
      type="text"
      ref="input"
      name="money"
      class="form-control text-right"
      :style="customStyle"
      v-currency="{currency: null, locale: 'ja', precision: 0, distractionFree: false}"
      v-model="displayValue"
      v-validate="validation"
      @blur="showBubble"
      @focus="isInputActive = true"
      @input="handleInput"
      >
  </div>
</template>
<script>
import { getValue, setValue } from 'vue-currency-input'
import Util from '@/common/utility'

export default {
  props: {
    value: {
      type: Number
    },
    validation: {
      type: String
    },
    product: {
      type: Object,
      default () {
        return null
      }
    },
    warehouseType: {
      type: String,
      default: 'amazon'
    },
    customStyle: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data: function () {
    return {
      isInputActive: false,
      isValidated: false,
      displayValue: this.value,
      bubbleMessage: null,
      validateMessage: null
    }
  },
  computed: {
    inputDirty () {
      return this.fields.money.dirty || this.isValidated
    }
  },
  methods: {
    validateAll () {
      this.isValidated = true
      this.$validator.validateAll()
    },
    handleInput () {
      if (parseInt(this.displayValue.replace(',', '')) !== this.value || this.isInputActive) {
        this.$emit('input', {
          product: this.product,
          price: getValue(this.$refs.input)
        })
      }
    },
    showBubble () {
      let validateMessages = {
        'required': '受取金額を入力してください',
        'moneyMin': '受取金額は1以上でなければなりません。',
        'numberLength': 'は6文字以内を入力してください。'
      }
      if (this.errors.has('money') && this.inputDirty) {
        let rule = this.errors.items ? this.errors.items[0].rule : null
        this.validateMessage = validateMessages[rule]
      } else {
        this.validateMessage = null
      }

      let priceWarning = this.comparePrice(this.product.offerPrice, this.product.amazonPrice)
      if (this.warehouseType === 'sc') {
        priceWarning = this.comparePrice(this.product.scOfferPrice, this.product.amazonPrice)
      }
      if (this.warehouseType === 'across') {
        priceWarning = this.comparePrice(this.product.acrossOfferPrice, this.product.amazonPrice)
      }

      if (priceWarning) {
        this.bubbleMessage = 'Amazon価格との差異が大きいです'
      } else {
        this.bubbleMessage = null
      }
    },
    // Amazonの価格より50％以上高い時, 50％以上安い時警告
    comparePrice (offerPrice, amazonPrice) {
      var checkResult = false
      var inputPrice = Number.parseInt(offerPrice)
      var basePrice = Number.parseInt(amazonPrice)
      if (this.isNumber(inputPrice) && this.isNumber(basePrice) && basePrice > 0) {
        const halfPrice = basePrice * 0.5
        if (inputPrice <= halfPrice) {
          checkResult = true
        }
        const oneHalfPrice = basePrice * 1.5
        if (inputPrice >= oneHalfPrice) {
          checkResult = true
        }
        if ((inputPrice > halfPrice) && (inputPrice < oneHalfPrice)) {
          checkResult = false
        }
      }
      return checkResult
    },
    isNumber (numVal) {
      // チェック条件パターン
      var pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/
      // 数値チェック
      return pattern.test(numVal)
    },
    formatAmount (value) {
      return (value === null || typeof value === 'undefined' || value === 0) ? '-' : `${Util.formatMoney(value)}`
    }
  },
  watch: {
    value: {
      handler () {
        setValue(this.$refs.input, this.value)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.product-bubble {
  z-index: 99;
}
.offer-price-bubble {
  left: -80px !important;
}
.offer-price-bubble::after, .offer-price-bubble::before {
  left: 40%;
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/ProductInputMoney.vue